/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Price_Ent_NameInputs */

const en_mk_price_ent_name = /** @type {(inputs: Mk_Price_Ent_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enterprise`)
};

const id_mk_price_ent_name = /** @type {(inputs: Mk_Price_Ent_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enterprise`)
};

/**
* | output |
* | --- |
* | "Enterprise" |
*
* @param {Mk_Price_Ent_NameInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_price_ent_name = /** @type {((inputs?: Mk_Price_Ent_NameInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Price_Ent_NameInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_price_ent_name(inputs)
	return en_mk_price_ent_name(inputs)
});